module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/footer.component.scss
// module id = 201
// module chunks = 1